var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$isEmpty(_vm.content))?_c('div',{staticClass:"announce"},[_c('p',{staticClass:"content"},_vm._l((_vm.contentList),function(item,index){return _c('span',{key:index,class:item.styleType},[_vm._v(_vm._s(item.content))])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }